import type { GroupBase, MultiValueProps, OptionProps, SelectComponentsConfig } from "react-select";
import { DirectoryUser } from "@/types/user";
import { UserAvatar } from "@/components/ui/userAvatar";

interface GuestValue {
  label: string;
  isNew: true;
}

export const SelectComponents: SelectComponentsConfig<DirectoryUser, true, GroupBase<DirectoryUser>> = {
  Option: (props: OptionProps<DirectoryUser, true, GroupBase<DirectoryUser>>) => {
    if ("isNew" in props.data && props.data.isNew) {
      const data = props.data as unknown as GuestValue;
      return (
        <div className="flex cursor-pointer px-3 py-1 align-middle text-sm" ref={props.innerRef} {...props.innerProps}>
          Guest {data.label}
        </div>
      );
    }
    return (
      <div
        className="flex cursor-pointer items-center px-3 py-1 align-middle text-sm"
        ref={props.innerRef}
        {...props.innerProps}
      >
        <UserAvatar user={props.data} size="xs" className="mr-2" />
        <div>
          {props.data.name} {props.data.surname} ({props.data.email})
        </div>
      </div>
    );
  },
  MultiValue: (props: MultiValueProps<DirectoryUser, true, GroupBase<DirectoryUser>>) => {
    if ("isNew" in props.data && props.data.isNew) {
      const data = props.data as unknown as GuestValue;
      return (
        <div className="flex cursor-pointer rounded bg-gray-100 px-3 py-1 align-middle text-sm" {...props.innerProps}>
          Guest {data.label}
        </div>
      );
    }
    return (
      <div className="m-0.5 flex max-w-[220px] items-center gap-1 rounded bg-gray-100 py-0.5 pl-1 pr-1.5 text-sm">
        <UserAvatar user={props.data} size="xs" className="shrink-0" />
        <span className="min-w-0 truncate" title={`${props.data.name} ${props.data.surname} (${props.data.email})`}>
          {props.data.name} {props.data.surname}
        </span>
        <span
          className="ml-0.5 shrink-0 cursor-pointer text-gray-500 hover:text-gray-800"
          {...props.removeProps}
          aria-label="Remove"
        >
          ×
        </span>
      </div>
    );
  },

  NoOptionsMessage: () => <div className="text-center text-sm">No data</div>,
};
